import React, { useRef, useState } from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Close, closeCircle, UploadImg } from "../../Svg";
import api from "../../utils/api";
import { toast } from "react-toastify";
import axios from "axios";

const MediaCard = ({ values, setFieldValue }) => {
    const imageRef = useRef(null);
    const videoRef = useRef(null);
    const [isUploading, setCoverUploading] = useState(false);
    const [loadings, setLoading] = useState(false)


    const handleImageChange = async (e, attribute, from) => {
        const files = e.target?.files || e.dataTransfer?.files;
        if (!files || files.length === 0) return;
        if (from == 'image') {
            setCoverUploading(true);
        } else {
            setLoading(true)
        }

        try {
            const existingFiles = values[attribute] || [];
            let uploadedFiles = [...existingFiles];

            for (const file of files) {
                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);
                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: { "Content-Type": file.type }
                    });

                    uploadedFiles = [...uploadedFiles, data?.data?.url];
                }
            }

            setFieldValue(attribute, uploadedFiles);
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file");
        } finally {
            if (from == 'image') {
                setCoverUploading(false);
            } else {
                setLoading(false)
            }
        }
    };



    const handleRemove = (attribute, index) => {
        setFieldValue(attribute, values?.assets?.image?.filter((_, i) => i !== index));
    };



    return (
        <div>
            <div className={styles.formSection}>
                <div className={styles.card}>
                    <h2 className={styles.addCatH2}>Media</h2>

                    {/* Image Upload */}
                    <div className={styles.imageUpload}>
                        <p className={styles.addCatLabel}>Photo</p>

                        <>


                            <div className={styles.imagePreviewContainer}>
                                {values.assets?.image?.length > 0 && (
                                    <div className={styles.uploadBox} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                        {values.assets.image.map((img, index) => (
                                            <div key={index} className={styles.previewContainer} style={{ display: 'flex' }}>
                                                <img src={img} alt="" className={styles.previewImage} />
                                               
                                            </div>
                                        ))}
                                    </div>
                                )}

                            </div>
                        </>
                    </div>

                    {/* Video Upload */}
                    <div className={styles.imageUpload}>
                        <p className={styles.addCatLabel}>Video</p>
                        
                            <>
                               

                                    <div className={styles.imagePreviewContainer}>
                                        {values.assets.video.length > 0 && (
                                            <div className={styles.uploadBox} style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                                {values.assets?.video?.map((video, index) => (
                                                    <div key={index} className={styles.previewContainer} style={{ display: 'flex', }}>
                                                        <video src={video} className={styles.previewVideo} controls style={{ width: '100%' }} />
                                                       
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                    </div>

                            </>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default MediaCard;
